import { gql } from '@apollo/client';
import { TEMPLATE_FIELDS_FRAGMENT } from './fragments';

/**
 * Get single template by ID
 */
export const GET_TEMPLATE = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetTemplate($tenantId: String!, $templateId: String!) {
    getTemplate(tenantId: $tenantId, templateId: $templateId) {
      ...TemplateFields
    }
  }
`;

/**
 * List templates with pagination
 */
export const LIST_TEMPLATES = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query ListTemplates($tenantId: String!, $limit: Int, $cursor: String) {
    listTemplates(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...TemplateFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

/**
 * Get templates by status
 */
export const GET_TEMPLATES_BY_STATUS = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetTemplatesByStatus($tenantId: String!, $status: TemplateStatus!) {
    getTemplatesByStatus(tenantId: $tenantId, status: $status) {
      ...TemplateFields
    }
  }
`;

/**
 * Get all versions of a template by name
 */
export const GET_TEMPLATE_VERSIONS = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetTemplateVersions($tenantId: String!, $name: String!) {
    getTemplateVersions(tenantId: $tenantId, name: $name) {
      ...TemplateFields
    }
  }
`;

/**
 * Get templates by category
 */
export const GET_TEMPLATES_BY_CATEGORY = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetTemplatesByCategory($tenantId: String!, $category: String!) {
    getTemplatesByCategory(tenantId: $tenantId, category: $category) {
      ...TemplateFields
    }
  }
`;

/**
 * Get templates pending approval
 */
export const GET_PENDING_APPROVAL_TEMPLATES = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetPendingApprovalTemplates($tenantId: String!) {
    getPendingApprovalTemplates(tenantId: $tenantId) {
      ...TemplateFields
    }
  }
`;

/**
 * Get templates by formula with optional success rate filter
 */
export const GET_TEMPLATES_BY_FORMULA = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  query GetTemplatesByFormula($tenantId: String!, $formulaId: String!, $minSuccessRate: Float) {
    getTemplatesByFormula(tenantId: $tenantId, formulaId: $formulaId, minSuccessRate: $minSuccessRate) {
      ...TemplateFields
    }
  }
`;
